/* =========================================================
   BB - HOLIDAY SHIPPING PAUSE POPUP (SESSION ONLY)
   - Shows ONCE per browser session
   - Safe with PageFly / EasySell (no z-index issues)
   - White, clean, BricoBello style
   ========================================================= */

(function () {
  // ===== CONFIG =====
  var SESSION_KEY = "bb_holiday_popup_seen_session";
  var SHOW_DELAY_MS = 700;
  var POPUP_ID = "bbHolidayPopup";
  var STYLE_ID = "bb-hp-white-style";

  // ===== SESSION CHECK =====
  function alreadySeenThisSession() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markSeenThisSession() {
    try {
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch (e) {}
  }

  // ===== STYLE =====
  function injectStylesOnce() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .bb-hp-backdrop{
        display:none;
        position:fixed;
        inset:0;
        background:rgba(0,0,0,.55);
        z-index:2147483647 !important;
        align-items:center;
        justify-content:center;
        padding:18px;
      }
      .bb-hp-modal{
        width:min(560px,92vw);
        background:#fff;
        border-radius:18px;
        box-shadow:0 20px 60px rgba(0,0,0,.18);
        font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;
        overflow:hidden;
      }
      .bb-hp-header{
        display:flex;
        justify-content:space-between;
        align-items:center;
        padding:16px 20px;
        border-bottom:1px solid #eee;
      }
      .bb-hp-brand{
        font-weight:900;
        font-size:13px;
        color:#ff7800;
        letter-spacing:.4px;
        text-transform:uppercase;
      }
      .bb-hp-close{
        width:36px;
        height:36px;
        border-radius:10px;
        border:1px solid #eee;
        background:#fff;
        font-size:22px;
        cursor:pointer;
        color:#777;
      }
      .bb-hp-body{
        padding:22px 20px 18px;
        text-align:center;
      }
      .bb-hp-title{
        margin:0 0 10px;
        font-size:22px;
        font-weight:900;
        color:#111;
      }
      .bb-hp-text{
        margin:0 0 12px;
        font-size:15.5px;
        color:#444;
        line-height:1.55;
      }
      .bb-hp-highlight{
        margin:14px auto;
        padding:12px 14px;
        border-radius:14px;
        background:#fff4ec;
        color:#ff7800;
        font-weight:900;
        font-size:15.5px;
        display:inline-flex;
        gap:8px;
        align-items:center;
      }

      .bb-hp-note{
        font-size:14.5px;
        color:#666;
        line-height:1.55;
      }

    .bb-hp-actions{
        margin-top:18px;
        display:flex;
        justify-content:center;
    }

      .bb-hp-btn{
        border:none;
        border-radius:999px;
        padding:13px 26px;
        font-size:16px;
        font-weight:900;
        cursor:pointer;
        background:#ff7800;
        color:#fff;
      }
      .bb-hp-btn:hover{ background:#e86d00; }
      .bb-hp-footer{
        padding:12px;
        font-size:12.8px;
        color:#999;
        border-top:1px solid #eee;
        text-align:center;
      }
    `;
    document.head.appendChild(style);
  }

  // ===== POPUP =====
  function ensurePopup() {
    if (document.getElementById(POPUP_ID)) return document.getElementById(POPUP_ID);

    var wrap = document.createElement("div");
    wrap.id = POPUP_ID;
    wrap.className = "bb-hp-backdrop";
    wrap.setAttribute("aria-hidden", "true");

    wrap.innerHTML = `
      <div class="bb-hp-modal" role="dialog" aria-modal="true">
        <div class="bb-hp-header">
          <div class="bb-hp-brand">🧡 BRICOBELLO · AVVISO SPEDIZIONI</div>
          <button class="bb-hp-close" id="bbHpClose">×</button>
        </div>
        <div class="bb-hp-body">
          <h3 class="bb-hp-title">Spedizioni temporaneamente sospese</h3>
          <p class="bb-hp-text">
            Le spedizioni sono sospese dal <strong>24 dicembre</strong> al <strong>1° gennaio</strong>.
          </p>
          <div class="bb-hp-highlight">
            📦 Ripartiamo il <strong>2 Gennaio</strong>
          </div>
          <p class="bb-hp-note">
            Puoi ordinare normalmente: prepareremo il tuo ordine e lo spediremo appena riprendiamo le attività.
          </p>
          <div class="bb-hp-actions">
            <button class="bb-hp-btn" id="bbHpOk">Ho capito</button>
          </div>
        </div>
        <div class="bb-hp-footer">Grazie per la pazienza · Buone Feste 🎁</div>
      </div>
    `;

    document.documentElement.appendChild(wrap);

    function close() {
      wrap.style.display = "none";
      wrap.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      markSeenThisSession();
    }

    wrap.querySelector("#bbHpClose").onclick = close;
    wrap.querySelector("#bbHpOk").onclick = close;
    wrap.onclick = e => { if (e.target === wrap) close(); };

    document.addEventListener("keydown", e => {
      if (e.key === "Escape" && wrap.style.display === "flex") close();
    });

    return wrap;
  }

  function openPopup() {
    if (alreadySeenThisSession()) return;
    injectStylesOnce();
    var wrap = ensurePopup();
    document.documentElement.style.overflow = "hidden";
    wrap.style.display = "flex";
    wrap.setAttribute("aria-hidden", "false");
  }

  function run() {
    if (alreadySeenThisSession()) return;
    setTimeout(openPopup, SHOW_DELAY_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
